import { Controller } from "stimulus";

const inactiveClasses = ["opacity-50", "cursor-not-allowed"];

export default class extends Controller {
  static targets = ["preview", "input", "form", "submitButton"];

  connect() {
    console.log("Logo upload controller connected");

    // Log all found elements for debugging
    console.log("DOM elements:", {
      element: this.element,
      previewTargets: this.previewTargets,
      inputTargets: this.inputTargets,
      formTargets: this.formTargets,
      submitButton: this.submitButtonTarget
    });

    this.#updateSubmitButton(false);
  }

  #updateSubmitButton(enabled) {
    for (const klass of inactiveClasses) {
      this.submitButtonTarget.classList.toggle(klass, !enabled);
      this.submitButtonTarget.disabled = !enabled;
    }
  }

  selectFile(event) {
    // Find the input directly as a fallback
    const input = this.element.querySelector('input[type="file"]');
    if (input) {
      input.click();
    } else {
      console.error("No file input found");
    }
  }

  preview(event) {
    const file = event.target.files[0];
    if (!file) return;

    // Find the preview directly as a fallback
    const preview = this.element.querySelector("img");
    if (preview) {
      const reader = new FileReader();
      reader.onload = e => {
        preview.src = e.target.result;
      };
      reader.readAsDataURL(file);
    }

    this.#updateSubmitButton(true);
  }

  submitForm(event) {
    event.preventDefault();
    console.log("Submit clicked");

    // Check if a file is selected in the input target
    if (this.inputTarget.files.length === 0) {
      console.log("No file selected, form submission prevented.");
      // Optionally, provide feedback to the user, e.g., an alert
      // alert("Please select a logo image first.");
      return; // Stop execution if no file is selected
    }

    // Find the form using the target (more robust than querySelector)
    if (this.hasFormTarget) {
      this.formTarget.submit();
    } else {
      // Fallback if target isn't found (though it should be)
      const form = this.element.querySelector("form");
      if (form) {
        form.submit();
        this.#updateSubmitButton(false);
      } else {
        console.error("No form found");
      }
    }
  }
}
